import { UIActionButton } from "common/components";
import { useDispatch, useSelector } from "common/utilities/react-redux";
import { activateModal } from "domains/modal/actions";
import type { KnowledgeType } from "entities/knowledge/types";
import { getCanRejectKnowledge } from "entities/permissions/selectors";

type KnowledgeRejectButtonProps = {
  hideButtonLabels?: boolean;
  knowledgeId: string;
  knowledgeType: KnowledgeType;
  onSuccessPath?: string;
  topicId: string;
};

export const KnowledgeRejectButton = ({
  hideButtonLabels,
  knowledgeId,
  knowledgeType,
  onSuccessPath,
  topicId,
}: KnowledgeRejectButtonProps) => {
  const dispatch = useDispatch();
  const canRejectKnowledge = useSelector(getCanRejectKnowledge);

  const onRejectButtonClick = (event: React.MouseEvent) => {
    event.stopPropagation();

    dispatch(
      activateModal({
        id: "KnowledgeRejectionReason",
        params: { knowledgeId, knowledgeType, onSuccessPath, topicId },
      }),
    );
  };

  if (!canRejectKnowledge) return null;

  return <UIActionButton type="reject" onClick={onRejectButtonClick} hideLabel={hideButtonLabels} />;
};
